import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import * as CONSTANTS from "../../CONSTANTS";

function AdminMemoryDripps({ currentAnnisite, user, setUpdateAction}) {
    const [drippList, setDrippList]                                 = useState(null);
    const [loading, setLoading]                                     = useState(false);

    useEffect(() => {
        collectMemoryDrippLists();
    },[]);

    const collectMemoryDrippLists = async () => {
        try{
            setLoading(true);
            
            const result = await axios.get(CONSTANTS.API_URL +"annivites/dripp/listing/v1/" + currentAnnisite._id, {
                headers: {
                    token: "Bearer " + user.accessToken
                }
            });

            setDrippList(result.data);
            setLoading(false);
        }catch(err){
            console.log(err);
            toast.error("Something went went wrong");
            setLoading(false);
        }
    }

    if (loading) {
        return <div className="p-4">Loading...</div>;
    }

    if (!drippList) {
        return <div className="p-4">No data found.</div>;
    }

  return (
    <div className="container mt-4">
        <h1 className="mb-2">{drippList.userName}'s Anniversary Memories</h1>
      <p className="text-muted">
        {drippList.spouseA} ❤️ {drippList.spouseB}
      </p>

      {drippList.dripps && drippList.dripps.length > 0 ? (
        <>
          {/* Tabs navigation */}
          <ul className="nav nav-tabs" id="drippTabs" role="tablist">
            {drippList.dripps.map((drip, index) => (
              <li className="nav-item" role="presentation" key={index}>
                <button
                  className={`nav-link ${index === 0 ? "active" : ""}`}
                  id={`tab-${index}`}
                  data-bs-toggle="tab"
                  data-bs-target={`#dripp-${index}`}
                  type="button"
                  role="tab"
                  aria-controls={`dripp-${index}`}
                  aria-selected={index === 0 ? "true" : "false"}
                >
                  Dripp {index + 1}
                </button>
              </li>
            ))}
          </ul>

          {/* Tabs content */}
          <div className="tab-content mt-3" id="drippTabsContent">
            {drippList.dripps.map((drip, index) => (
              <div
                key={index}
                className={`tab-pane fade ${
                  index === 0 ? "show active" : ""
                }`}
                id={`dripp-${index}`}
                role="tabpanel"
                aria-labelledby={`tab-${index}`}
              >
                <h4>{drip.experience || "No Experience Title"}</h4>
                <p className="text-muted">Event Order: {drip.eventOrder}</p>

                {drip.featureUrl && (
                  <img
                    src={drip.featureUrl}
                    alt="feature"
                    className="img-fluid rounded mb-3"
                  />
                )}

                {drip.eventMessages && drip.eventMessages.length > 0 && (
                  <div className="mb-3">
                    <h5>Messages</h5>
                    <ul className="list-group">
                      {drip.eventMessages.map((msg, i) => (
                        <li key={i} className="list-group-item">
                          <strong>{msg.name}</strong>: {msg.message}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {drip.imageList && drip.imageList.length > 0 && (
                  <div>
                    <h5>Images</h5>
                    <div className="row">
                      {drip.imageList.map((img, i) => (
                        <div key={i} className="col-md-6 mb-3">
                          <img
                            src={img.imageUrl}
                            alt={img.caption}
                            className="img-fluid rounded"
                          />
                          <p className="text-muted mt-1">{img.caption}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </>
      ) : (
        <p>No dripps available.</p>
      )}
    </div>
  )
}

export default AdminMemoryDripps